import { Button } from "@/components/ui/button";
import { TrendingUp, Users, Package } from "lucide-react";
import { useNavigate } from "react-router-dom";
const DashboardHeader = () => {
  const navigate = useNavigate();
  
  return (
    <header className="mb-6 sm:mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r from-blue-600 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg">
            <TrendingUp className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-800">لوحة التحكم الرئيسية</h1>
          </div>
        </div>
        
        <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
          <Button 
            onClick={() => navigate("/create-package")} 
            size="sm"
            className="bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 w-full sm:w-auto"
          >
            <Package className="w-3 h-3 sm:w-4 sm:h-4 ml-2" />
            <span className="text-xs sm:text-sm">إنشاء باقة سياحية</span>
          </Button>
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => navigate("/clients")}
            className="w-full sm:w-auto"
          >
            <Users className="w-3 h-3 sm:w-4 sm:h-4 ml-2" />
            <span className="text-xs sm:text-sm">العملاء</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
export default DashboardHeader;